import React from "react";
import { Column, ColumnId } from ".";
import CustomerCallStatusCellContent from "../components/CustomerCallStatusCellContent";
import base from "./base";

function customerCallStatus({ width, onResize }: Column.Options) {
	return base(
		ColumnId.CustomerCallStatus,
		(item) => <CustomerCallStatusCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default customerCallStatus;
